
  import ScreenSize from '@/mixins/ScreenSize';
  export default {
    name: 'SectionTestimonialCards',
    components: {
      TestimonialCard: () => import('@/components/TestimonialCard'),
      OrganizationTestimonialCard: () =>
        import('@/components/OrganizationTestimonialCard'),
    },
    mixins: [ScreenSize],
    props: {
      section: {
        type: Object,
        required: false,
        default: () => {},
      },
    },
    serverCacheKey(props) {
      return (
        'section-testmonial-cards-' + props.section.id + '-' + props.device
      );
    },
    data() {
      return {
        testimonials: [],
      };
    },
    created() {
      const shuffled = this.section.testimonials
        .map((value) => ({value, sort: Math.random()}))
        .sort((a, b) => a.sort - b.sort)
        .map(({value}) => value);
      this.testimonials = shuffled.slice(0, this.section.num_testimonials);
    },
  };
